var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.addressVerified)?_c('a',{staticClass:"font-12 text-color-light-green link-hover-color-dark -no-line ml-auto",attrs:{"role":"button"},on:{"click":_vm.reSign}},[_vm._v("Sign")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }